import gql from "graphql-tag";

export const OC_ASSETS_SUBSCRIPTION = gql`
  subscription assetsSubscription {
    assetsSubscription
  }
`;
